import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../../../store/modalSlice";
import {refundTableColumnsConfig} from "./refundTableColumnsConfig"

import { Table } from "../../../component/table/Table";
const statusMap = {
  Approve: 15,
  Reject: 21,
};

export const RefundTablePage = ({ data }) => {
  const [columnDefs, setColumnDefs] = useState([]);
  const dispatch = useDispatch();
  console.log("refund", data)

  const handleOpenModal = useCallback(
    (rowData, identifier) => {
      console.log("identifier:", identifier); // Optional debug

      dispatch(
        openModal({
          component: "DynamicForm",
          uiData: {
            heading:`${identifier} Request`,
            primaryButtonLabel: identifier,
            isGridRequired: true,
            
          },
          configData: {
            ...rowData,
           status: statusMap[identifier],
          },
          operationType: identifier,
          module: "refund",
        })
      );
    },
    [dispatch]
  );

  useEffect(() => {
    setColumnDefs(
      refundTableColumnsConfig["refund"](handleOpenModal)
    );
  }, [handleOpenModal]);

  return <Table data={data} columns={columnDefs} />;
};
